import React, { useState, useEffect } from 'react'
import Fetcher from '../../hoc/FetcherSetting/FetcherSetting'
import { useQuery, useMutation } from 'react-query'
import { useParams } from 'react-router'
import { useHistory } from "react-router-dom";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../hoc/formikComponents/FormikControl'
import ToastInstance from '../../hoc/NotificationSettings/ToastInstance'
import { useQueryClient } from 'react-query'


function RegisterUser() {
    const queryClient = useQueryClient();
    const history = useHistory();
    const { usercode } = useParams()
    const [APIUrl, setAPIUrl] = useState('/api/profile/get/user/' + usercode)
    const [initialValues, setInitialValues] = useState({
        _id: "",
        userCode: 0,
        firstName: "",
        lastName: "",
        emailId: "",
        mobileNo: "",
        role    : localStorage.getItem("userRole") ==="Executive(Support)" ? "Client" :"",
        designation: "",
        manager:"",
        managerCode:"",
        createdBy:localStorage.getItem("userCode"),
        createdByRole : localStorage.getItem("userRole")

  
    })
    const[managerState,setState]=useState(false)

    const validationSchema = Yup.object({
        firstName: Yup.string().required('Required!!'),
        lastName: Yup.string().required('Required!!'),
        emailId: Yup.string().email('Invalid Email Format').required('Required!!'),
        mobileNo: Yup.string().trim().required('Required!!').matches(/^(\+91[\-\s]?)?[0]?(91)?[789]\d{9}$/, "Phone Number is Invalid!!!"),
        designation: Yup.string().required('Required!!')
    })
    const roleList = [
        { key: 'Select', value: '-' },
        { key: 'Management', value: 'Management' },
        { key: 'Lead Auditor', value: 'Lead Auditor' },
        { key: 'Asst Auditor', value: 'Asst Auditor' },
        { key: 'Auditor', value: 'Auditor' },
        { key: 'Executive(Support)', value: 'Executive(Support)' },
        { key: 'Manager', value: 'Manager' },
        { key: 'Accounts', value: 'Accounts' },
        { key: 'Client', value: 'Client' },
        {key :'Secretariat',value:'Secretariat'},
        {key :'MT',value:'MT'},

    ]

    const executiveroleList = [
                                    { key: 'Client', value: 'Client' },

                              ]
    const handleRoute = () =>{ 
                            history.push("/admin/selfresetpassword/"+localStorage.getItem("userCode"));
                              }
    const onSubmit = (values, { setSubmitting, resetForm }) => {
        resetForm({ _id: "", firstName: "", lastName: "", emailId: "", mobileNo: "", manager:""})
        if (values._id === '') {
            mutation.mutate(values)
        } else {
         
            mutationEdit.mutate(values)
        }
    }
    const mutation = useMutation((params) => Fetcher('post', '/api/user/post/registeruser', params), {
        onSuccess(data) {
        
            if (data.data.errorCode === 0  && data.data.response.role === 'Lead Auditor' || data.data.response.role === 'Asst Auditor' || data.data.response.role === 'Auditor' ) {
                window.location.href = '/'+localStorage.getItem("role")+'/auditordetails/' + data.data.response.userCode
            }
             else
              if(data.data.errorCode === 0) 
             { 
                ToastInstance('Success', 'Succesfully Registered')
                window.location.href = '/'+localStorage.getItem("role")+'/view/' + data.data.response.userCode
            } else {
                
                var msg = 'Registration - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Registration' + error)
        }
    })



    const mutationEdit = useMutation((params) => Fetcher('patch', '/api/profile/patch/updateuserdetails', params), {
        onSuccess(data) {
            if (data.data.errorCode === 0) {
                ToastInstance('Success', 'Data Updated')
                window.location.href = '/'+localStorage.getItem("role")+'/view/' + usercode
            } else {
                var msg = 'Registration - ' + data.data.errorMsg;
                ToastInstance('Error', msg)
            }
        },
        onError(error) {
            console.log('Got error from backend', error)
            ToastInstance('Error', 'Registration' + error)
        }
    })
    const { data: userdata, isLoading } = useQuery(
        'userdetails',
        () => { if (usercode) return Fetcher('get', '/api/profile/get/userdetails/' + usercode, {}) })
   
    useEffect(() => {
        if (userdata && initialValues.userCode === 0) {
            var tempData = userdata.data.response
            tempData.mobileNo = userdata.data.response.mobNum
            if(tempData.role === "Executive(Support)"){
              
                setState(true)
                tempData.manager= userdata.data.response.manager 
                tempData.managerCode= userdata.data.response.managerCode 
                          
            }
            else{
                setState(false)
            }
            
            setInitialValues(tempData)
           
        }
    }, [userdata && !isLoading])

     const { data: managerdata, isLoading: managerList } = useQuery(
            'mangerdetails',
            () => Fetcher('get', '/api/profile/get/keyvalueformanager', {}))
    if (managerList  ) return <h1>Loading</h1>
    
    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
        >
            {
                formik => <Form>
                    <div className="content-wrapper" style={{ "border": "1px solid rgba(0, 0, 0, 0.03)", "minHeight": "500px", "borderRadius": "4px" }}>
                        <section className="content-header">
                            <div className="container-fluid">
                                <div className="row mb-2">
                                    <div className="col-sm-6 text-primary">
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className="content">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="card-body" >
                                            <div className="row">
                                                <div className="col-lg-12">


                                                    <div className="formOuterDiv">

                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" label='First Name' name='firstName' />
                                                            <FormikControl control='input' type="text" label='Last Name' name='lastName' />

                                                        </div>
                                                        <div className="form2RowDiv">
                                                            <FormikControl control='input' type="text" label='Email Id' name='emailId' />
                                                            <FormikControl control='input' type="text" label='Mobile Number' name='mobileNo' />

                                                        </div>


                                                        <div className="form2RowDiv">
                                                           { 
                                                           localStorage.getItem("userRole")==="Executive(Support)"?
                                                           <FormikControl control='select'  label='Role' name='role'  options={executiveroleList} disabled={true} 
                                                           
                                                           
                                                           />
                                                           :
                                                            <FormikControl control='select' options={roleList} label='Role' name='role'
                                                                onChange={(e)=> {
                                                                        formik.setFieldValue(`role`,e.currentTarget.value)
                                                                        e.currentTarget.value==='Executive(Support)' ?  
                                                                        setState(true)
                                                                    :
                                                                        setState(false)

                                                                        
                                                            }}
                                                            
                                                            />
                                                            
                                                            
                                                            }
                                                            <FormikControl control='input' type="text" label='Designation' name='designation' />
                                                        </div>

                                                        <div className="form2RowDiv manager">
                                                            {
                                                                managerState ?
                                                                 
                                                                 <FormikControl control='selectNACECode' options={managerdata.data.response} label='Manager' name='managerCode' 
                                                                    onChange={(e) => {
                                                                    formik.setFieldValue(`managerCode`, e.value)
                                                                    formik.setFieldValue(`manager`, e.label)
                                                                }}
                                                                />
                                                                :""
                                                        
                                                            }
                                                        </div>
                                                        <div className="card-footer">
                                <div className="row">
                                <div className="col-sm-8"></div>
                                <div className="col-sm-2">
                                    <button className="btn btn-primary float-right" type="button" onClick={()=>handleRoute()}>Reset Password</button>
                                </div>
                                <div className="col-sm-2">
                                <button type="submit" className="btn btn-primary" disabled={!formik.isValid}>Submit</button>
                                </div>
                                
                            </div>
                            </div>
                                                        

                                                        {/* <div className="submitButtonDiv">
                                                         
                                                            <button type="submit" className="btn btn-primary" disabled={!formik.isValid}>Submit</button>
                                                       
                                                        </div> */}
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                </Form>
            }
        </Formik>
    )
}

export default RegisterUser